import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { call, delay, select, take, takeEvery } from 'redux-saga/effects';
import { GlobalActions, GlobalPut, ModalType } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { VwgActions } from '../vwgActions';

export function* watchPlzRequiresUwSubmissionBlocked(): SagaIterator {
  yield takeEvery(
    VwgActions.PLZ_REQUIRES_UW_SUBMISSION_BLOCKED,
    safeSaga(plzRequiresUwSubmissionBlockedHandler, App.VWG_V2),
  );
}

export function* plzRequiresUwSubmissionBlockedHandler(): SagaIterator {
  const globalPut = GlobalPut.getInstance();

  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().requestModal(ModalType.PLZ_REQUIRES_UW_CHECK_ERROR),
  );

  yield take(GlobalActions.CLOSE_MODAL);

  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().navigationRequested({ appId: App.SHOP_DASHBOARD }),
  );

  yield delay(0);
  const state: IAppState = yield select();
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().restoreStreckeSnapshot(App.VWG_V2, state.angebotsId),
  );
}
